module.exports = __webpack_public_path__ + "img/lei.2667ee8.png";